import { useCallback } from "react";

import { losPipelineApi } from "../../api/losPipelineApi";
import { dealsForTab } from "../../constants/pipelineTabs";
import { useDocumentTitle } from "../../hooks/useDocumentTitle";
import { BOARD_LAYOUT_SCOPE } from "../../hooks/utils/useUserPreferences";
import PipelineTableScreen from "./PipelineTableScreen";

// Every loan on this tab shares the "Clear To Close" loanStatus, so the status
// switcher slices by subStatus instead (mirrors LOAN_SUBSTATUS_MAP["Clear To
// Close"] on the LO pipeline).
const CLOSING_SUBSTATUSES = ["Docs Out", "Docs Back"];

// Closing tab. Per loan_and_auth_endpoints.md §3–§4 there is NO per-stage
// endpoint — this is a client-side slice of the shared
// /loportal/user_pipeline payload, filtered to the "Closing" loan
// status (Clear To Close).
const ClosingPipelineScreen = () => {
  useDocumentTitle("Closing Pipeline");
  const fetchData = useCallback(({ onSuccessFn, onFailFn, onErrorFn }) => {
    const onError = onFailFn || onErrorFn || (() => {});
    losPipelineApi
      .getUserPipeline()
      .then((deals) => onSuccessFn?.(dealsForTab(deals, "CLOSING")))
      .catch(onError);
  }, []);

  return (
    <PipelineTableScreen
      title="Closing"
      storageKeyPrefix="closing-pipeline"
      // Shares the saved-view list with Pre-Close (same column set) and syncs to
      // the user profile; the default-layout pointer stays per board.
      layoutScope={BOARD_LAYOUT_SCOPE}
      syncLayoutsToProfile
      fetchData={fetchData}
      statusField="subStatus"
      statusOptions={CLOSING_SUBSTATUSES}
    />
  );
};

export default ClosingPipelineScreen;
